
<!-- ==  GLOBAL LOADER  == -->

<div class="loader" *ngIf="loading$ | async">
  <div class="spinner-border spinner-border-lg text-primary" role="status">
      <span class="sr-only">Loading...</span>
  </div>
</div>

<nb-layout>
  <nb-layout-column>
    <router-outlet></router-outlet>

  

  </nb-layout-column>
</nb-layout>